import ForSpeshialists from "../news/forSpechialists"
import News from "../news/newsComponent"
import "./main.css"
import Slider from "./slider/slider"


import VK from "react-vk";
import About from "../news/about";


export default function Main () {

    return (
        <span>
            <span className="main-block">
            <Slider/>
            <p className="main-block-text">
                <h1>Приволжская федерация иппотерапии и адаптивного конного спорта </h1> – социально ориентированная некомерческая организация.
                Наша цель: сделать иппотерапию и адаптивный конный спорт доступными и широкими практиками.
                Мы организуем и проводим реабилитационные мероприятия, соревнования разных уровней для людей с ОВЗ и фестивали.
            </p>
            </span>
            <VK apiId={51601474}>
                <span className="block" id="news">
                    <h2>Новости и события:</h2>
                    <News/>
                </span>

                <span className="block" id="for-specialists">
                    <h2>Специалистам:</h2>
                    <ForSpeshialists/>
                </span>

                <span className="block" id="about">
                    <h2>О нас:</h2>
                    <About/>
                </span>
            </VK>
       </span>
    )
}